module.exports = __webpack_public_path__ + "assets/a246fbc7e580bb2f698dbcbda43e3beb.mp3";